import { IComponentController } from 'angular';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaire, IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPageMr0125 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    monoOccurrence: IMonoOccurrence,
    formulairePci: IFormulaire;
    pfaMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Mr0125Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass) {

    const vm: IPageMr0125 = this;

    vm.$onInit = $onInit;

    function $onInit() {
        vm.monoOccurrenceOptions = {
            noId: true,
        };
        vm.formulairePci = new Formulaire('LBL_BLC_PCI', [
            new FormulaireItem('vaesynemp'),
            new FormulaireItem('vaemajemp'),
            new FormulaireItem('vaepcifctann'),
            new FormulaireItem('vaepcisaippa'),
            new FormulaireItem('pcihreannsfu', { largeur: 33 }),
            new FormulaireItem('pciagefinasssal', { largeur: 33 }),
            new FormulaireItem('pcidurmaxasssal', { largeur: 33 })
        ]);

        vm.pfaMultiOccurrenceOptions = {
            fonctions:{
                 nouveau: (data:any) => data.vaepcifctann === 'J',
                 supprime: (data:any) => data.$parent.vaepcifctann === 'J',
                 edition: (data:any) => data.$parent.vaepcifctann === 'J',
            },
            colonnesVisibles: [
                { nom: 'pfadatvig', largeur: 100 },
                { nom: 'pfafct', largeur: 115 }
            ],
            formulaire: new Formulaire([
                new FormulaireItem('pfadatvig'),
                new FormulaireItem('pfafct')
            ])
        };
    }
}
